import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedName from 'I18n/components/FormattedName';
import UISelect from 'UIComponents/input/UISelect';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import useApprovers from '../hooks/useApprovers';
import { useApprovalContext } from '../hooks/useApprovalContext';
import { maxNumberOfApprovers } from '../utils/approvalModalUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export function ApproverSelect({
  value,
  onChange
}) {
  const approval = useApprovalContext();
  const currentUserId = approval.meta.currentUser.user_id;
  const {
    approvalType,
    approvalAction
  } = approval.meta;
  const {
    approvers,
    isLoading
  } = useApprovers(approvalType, approvalAction);
  const options = useMemo(() => approvers.filter(approver => approver.activeUserId !== currentUserId).map(item => Object.assign({
    // text is not visible, only used for searching
    // dropdownText and buttonText is what the user sees
    text: `${item.firstName} ${item.lastName} ${item.email}`,
    dropdownText: /*#__PURE__*/_jsx(FormattedName, {
      givenName: item.firstName,
      familyName: item.lastName,
      email: item.email
    }),
    buttonText: /*#__PURE__*/_jsx(FormattedName, {
      givenName: item.firstName,
      familyName: item.lastName,
      email: item.email
    }),
    value: item.ownerId,
    help: item.email
  }, item)), [currentUserId, approvers]);
  const onChangeApprover = evt => {
    onChange(evt.target.value);
  };
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approvers"
    }),
    required: true,
    tooltipProps: {
      use: 'longform'
    },
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalModal.approverTooltip"
    }),
    help: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalModal.approverSelectHelp"
    }),
    error: value.length > maxNumberOfApprovers,
    validationMessage: value.length > maxNumberOfApprovers && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approvalModalSelectError",
      options: {
        maxNumberOfApprovers,
        count: value.length - maxNumberOfApprovers
      }
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      anchorType: "button",
      isLoading: isLoading,
      "data-test-id": "product-approvals-approver-select",
      value: value,
      onChange: onChangeApprover,
      options: options,
      multi: true,
      multiCollapseLimit: 3,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.selectApprover"
      })
    })
  });
}
export default ApproverSelect;